import { Decoration } from '@atlaskit/editor-prosemirror/view';
import { filterDecorationByKey, SpellingAndGrammarDecorations } from '.';
export const removeSpellingDecoration = ({
  decorationSet,
  pluginState
}) => {
  return decorationSet.remove(filterDecorationByKey(SpellingAndGrammarDecorations.SPELLING_ERROR, decorationSet));
};
export const addSpellingDecoration = ({
  decorationSet,
  tr,
  pluginState
}) => {
  const {
    diffObjects
  } = pluginState;
  const decorations = diffObjects === null || diffObjects === void 0 ? void 0 : diffObjects.map(({
    from,
    to
  }) => Decoration.inline(from, to, {
    class: `ai-suggestions`,
    id: 'ai-sg',
    'data-testid': `ai-suggestions`
  }, {
    key: `${SpellingAndGrammarDecorations.SPELLING_ERROR}_${from}_${to}`
  }));
  if (!!(decorations !== null && decorations !== void 0 && decorations.length)) {
    return decorationSet.add(tr.doc, decorations);
  }
  return decorationSet;
};